import { useState } from 'react';

export function usePDFImport() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function importarPDF(file, tipo, extras = {}) {
    setLoading(true);
    setError(null);

    try {
      // Converter PDF para base64
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      const response = await fetch('/.netlify/functions/extrair-pdf', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pdfBase64: base64, tipo, ...extras }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Erro ao processar PDF');
      }

      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  return { importarPDF, loading, error };
}
